import {ISubmissionProps} from '../../resources/submission';

export const getIndicators = (submissions: ISubmissionProps[]) => {
    let value = 0;

    submissions.forEach(submission => {
        if (['3', '4'].includes(submission.domanda22?.toString() ?? '')) {
            value++;
        }
    })

    return value;
}